module.exports = __webpack_public_path__ + "img/tdashboard.6087e19f.svg";